module.exports = __webpack_public_path__ + "img/head-picture.bd5c155c.png";